import { z } from "zod";

export const formSchema = z.object({
    name: z.string().min(1, "forms.general-validation.please_enter_user_name"),
    system_name: z.string().min(1, "forms.general-validation.please_enter_system_name"),
    offers: z.array(z.string()).optional(),
    country_id: z.number().nullable().optional(),
    category: z.string().nullable().optional(),
    label_ids: z.array(z.string()).optional(),
});

export type FormStructureFormData = z.infer<typeof formSchema>;
